import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import {
  useLazyGetHouseRecipeAllocationQuery,
  useLazyGetUnloadAllocationQuery,
} from '../../loadsEndpoints';

const VolumeInput = ({ setLoadState, compartment, validateVolume, validationState }) => {
  const { compartmentId, loadType, recipe, products, product, volume } = compartment ?? {};

  const isCustom = R.propEq('loadTypeId', 1, loadType);
  const isHouse = R.propEq('loadTypeId', 2, loadType);
  const isUnload = R.propEq('loadTypeId', 3, loadType);

  const volumeLens = R.lensPath(['compartments', compartmentId, 'volume']);

  const { isFetching: isFetchingCustomRecipeAllocation } = useLazyGetHouseRecipeAllocationQuery();
  const { isFetching: isFetchingHouseRecipeAllocation } = useLazyGetHouseRecipeAllocationQuery();
  const { isFetching: isFetchingUnloadAllocation } = useLazyGetUnloadAllocationQuery();

  const handleVolumeChange = R.compose(
    setLoadState,
    R.set(volumeLens),
    x => x.toLocaleString(),
    R.unless(R.isEmpty, parseInt),
    R.tap(validateVolume),
    R.replace(/\D/g, ''),
    R.path(['target', 'value'])
  );

  const volumeDisabled =
    R.and(isCustom, R.isNil(recipe)) ||
    R.and(
      isHouse,
      R.or(R.isNil(recipe), R.any(R.o(R.isNil, R.prop('supplier')), R.values(products)))
    ) ||
    R.and(isUnload, R.isNil(product));

  // prettier-ignore
  const EndAdornment = isFetchingCustomRecipeAllocation || isFetchingHouseRecipeAllocation || isFetchingUnloadAllocation
      ? <CircularProgress color="inherit" size={16} />
      : <InputAdornment position="end">gal</InputAdornment>

  return (
    <TextField
      disabled={volumeDisabled}
      error={validationState?.error}
      fullWidth
      helperText={validationState?.message}
      label="Volume"
      onChange={handleVolumeChange}
      slotProps={{
        input: {
          endAdornment: EndAdornment,
        },
      }}
      value={volume}
    />
  );
};

VolumeInput.propTypes = {
  compartment: PropTypes.shape({
    loadType: PropTypes.shape({}),
    product: PropTypes.shape({}),
    products: PropTypes.shape({}),
    recipe: PropTypes.shape({}),
    supplier: PropTypes.shape({}),
  }).isRequired,
  loadState: PropTypes.shape({
    compartments: PropTypes.shape({}),
    location: PropTypes.shape({}),
  }).isRequired,
  setLoadState: PropTypes.func.isRequired,
  validateVolume: PropTypes.func.isRequired,
  validationState: PropTypes.shape({
    error: PropTypes.bool,
    message: PropTypes.string,
  }).isRequired,
};

export default VolumeInput;
